import { render, staticRenderFns } from "./CollapseOrgAndDevice.vue?vue&type=template&id=3dec3ddb&"
import script from "./CollapseOrgAndDevice.vue?vue&type=script&lang=js&"
export * from "./CollapseOrgAndDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CollapseOrgAndDevice.vue"
export default component.exports